export default __webpack_public_path__ + "static/media/qatar.0d84d7d9.svg";